// Scrips.Patient sends UTC timestamps with no zone marker (see `patients/lib/lab-results.ts` "Times").
// JavaScript reads such a string as browser-local time, so mark it as UTC before it becomes a Date.
// Shared by the lab results and the ambient scribe surfaces.

/** An API timestamp as the UTC instant it is (`…Z`); one that carries a zone, or a bare date, kept. */
export function asUtcInstant(iso: string | null | undefined): string | undefined {
  const t = iso?.trim();
  if (!t) return undefined;
  if (/(Z|[+-]\d{2}:?\d{2})$/i.test(t) || !/T\d{2}:\d{2}/.test(t)) return t;
  return `${t}Z`;
}
